import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { Controls } from '../../components/controls/Controls';
import { Form, useForm } from '../../components/useForm';

const initialFieldValues = {
    id: 0,
    parameterName: '',
    attributeSeqno: 1,
    attributeName: '',
    attributeValue: '',
};

export default function GenericParametersForm(props) {
    const { addOrEdit, recordForEdit } = props;

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm,
        // eslint-disable-next-line no-use-before-define
    } = useForm(initialFieldValues, true, validate);

    function validate(fieldValues = values) {
        const temp = { ...errors };
        if ('parameterName' in fieldValues) {
            temp.parameterName = fieldValues.parameterName ? '' : 'Campo Requerido';
        }
        if ('attributeName' in fieldValues) {
            temp.attributeName = fieldValues.attributeName ? '' : 'Campo Requerido';
        }
        if ('attributeValue' in fieldValues) {
            temp.attributeValue = fieldValues.attributeValue ? '' : 'Campo Requerido';
        }
        setErrors({ ...temp });
        if (fieldValues === values) {
            return Object.values(temp).every((x) => x === '');
        }
        return true;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            addOrEdit(values, resetForm);
        }
    };

    useEffect(() => {
        if (recordForEdit != null) {
            setValues({ ...recordForEdit });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordForEdit]);

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container>
                <Grid item xs={6}>
                    <Controls.Input
                        error={errors.parameterName}
                        label='Parameter Name'
                        name='parameterName'
                        onChange={handleInputChange}
                        value={values.parameterName}
                    />
                    <Controls.Input
                        error={errors.attributeName}
                        label='Attribute Name'
                        name='attributeName'
                        onChange={handleInputChange}
                        value={values.attributeName}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Controls.Input
                        inputProps={{ min: 1 }}
                        label='Attribute Seq No'
                        name='attributeSeqno'
                        onChange={handleInputChange}
                        sx={{
                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { display: 'none' },
                            '& input[type=number]': { MozAppearance: 'textfield' },
                        }}
                        type='number'
                        value={values.attributeSeqno}
                    />
                    <Controls.Input
                        error={errors.attributeValue}
                        label='Attribute Value'
                        name='attributeValue'
                        onChange={handleInputChange}
                        value={values.attributeValue}
                    />
                    <div>
                        <Controls.Button text='Guardar' type='submit' />
                        <Controls.Button
                            color='default'
                            onClick={resetForm}
                            text='Reset'
                        />
                    </div>
                </Grid>
            </Grid>
        </Form>
    );
}
